import {PortableText} from '@portabletext/react'
import {HiMiniArrowRight} from 'react-icons/hi2'
import {Link} from '@tanstack/react-router'
import clsx from 'clsx'
import CmsImage, {ImageProps} from '~/components/content/CmsImage'

type DescriptionProps = Array<{
    children?: Array<{
        marks?: Array<string>
        text?: string
        _type: 'span'
        _key: string
    }>
    style?: 'blockquote' | 'h2' | 'h3' | 'h4' | 'normal'
    listItem?: 'bullet' | 'number'
    markDefs?: Array<{
        href?: string
        _type: 'link'
        _key: string
    }>
    level?: number
    _type: 'block'
    _key: string
}>

type LinkProps = {
    label: string
    link: string
}

type TextWithIllustrationProps = {
    className?: string
    title?: string
    description: DescriptionProps
    link?: LinkProps
    image: ImageProps & {backgroundColor?: string}
    imagePosition: 'left' | 'right'
}

const TextWithIllustration = ({
    className,
    title,
    description,
    link,
    image,
    imagePosition,
}: TextWithIllustrationProps) => {
    return (
        <div className={clsx('inline-block w-full', className)}>
            <div className="backdrop-blur transform-gpu bg-gray-700/10 w-full max-w-screen-xl xl:rounded-2xl mx-auto mt-16 md:my-8">
                <div
                    className={clsx(
                        'px-4 sm:px-6 mx-auto max-w-screen-xl flex flex-col justify-center gap-6 md:gap-10 md:my-6',
                        imagePosition === 'left' ? 'md:flex-row' : 'md:flex-row-reverse'
                    )}
                >
                    <div className="relative -mt-16 md:-my-8 flex-1 w-full mx-auto aspect-[15/7] md:aspect-auto md:max-w-sm">
                        <CmsImage
                            className="size-full rounded-2xl shadow-2xl object-cover overflow-hidden absolute inset-0"
                            image={image}
                            backgroundColor={image.backgroundColor}
                            mode="cover"
                            sizes="400px"
                            loading="eager"
                        />
                    </div>
                    <div className="mb-6 flex-1 w-full px-4 md:px-0 md:my-6 flex flex-col gap-4">
                        {!!title && <h2 className="text-2xl md:text-4xl font-bold">{title}</h2>}
                        <div className="flex-1">
                            <PortableText value={description} />
                        </div>
                        {!!link && (
                            <div>
                                <Link
                                    to={link.link}
                                    className="flex flex-row items-center gap-1 font-medium text-green-600 md:text-lg"
                                >
                                    <span>{link.label}</span>
                                    <HiMiniArrowRight className="size-4 md:size-5" />
                                </Link>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TextWithIllustration
